import { User } from "../..";
import PropTypes from "prop-types";
import styles from "./AddUserModal.module.scss";
import { useEffect } from "react";
import BasicButton from "../../../../BasicButton";

interface AddUserModalProps {
  isOpen: boolean;
  newUser: Partial<User>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleModalClose: () => void;
  handleSubmit: (e: React.FormEvent) => void;
}

export const AddUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  newUser,
  handleInputChange,
  handleModalClose,
  handleSubmit,
}) => {
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleModalClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, handleModalClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleModalClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.modalContent}>
          <div className={styles.header}>
            <h2 className={styles.title}>Add user</h2>
            <button
              type="button"
              className={styles.closeButton}
              onClick={handleModalClose}
              aria-label="Close"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M15 5L5 15M5 5L15 15"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className={styles.inputContainer}>
              <input
                className={styles.input}
                type="text"
                name="name"
                placeholder="Name"
                value={newUser.name ?? ""}
                onChange={handleInputChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={newUser.email ?? ""}
                onChange={handleInputChange}
                className={styles.input}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={newUser.phone ?? ""}
                onChange={handleInputChange}
                className={styles.input}
              />
              <input
                type="text"
                name="password"
                placeholder="Password"
                value={newUser.password ?? ""}
                onChange={handleInputChange}
                className={styles.input}
              />
            </div>
            <div className={styles.footer}>
              <BasicButton
                type="button"
                onClick={handleModalClose}
                title="Cancel"
                variant="secondary"
              />
              <BasicButton
                type="submit"
                title="Add"
                variant="primary"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

AddUserModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  newUser: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
